import { render, staticRenderFns } from "./AllPatent.vue?vue&type=template&id=70e06544&scoped=true&"
import script from "./AllPatent.vue?vue&type=script&lang=js&"
export * from "./AllPatent.vue?vue&type=script&lang=js&"
import style0 from "./AllPatent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AllPatent.vue?vue&type=style&index=1&id=70e06544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e06544",
  null
  
)

export default component.exports